/* ============================================================
   Cart Drawer Horizon — assets/cart-drawer.js
   
   - Ouvre le drawer au clic sur #cart-icon-bubble
   - Ferme via croix, overlay, Escape
   - Update quantités via API AJAX Shopify
   - Suppression d'articles
   - Ajout produit upsell
   - Carousel "Vous aimerez aussi"
   ============================================================ */
(function () {
  'use strict';

  const drawer   = document.getElementById('hn-cart-drawer');
  const overlay  = document.getElementById('hn-cart-overlay');
  const closeBtn = document.getElementById('hn-cart-close');
  const cartTrigger = document.getElementById('cart-icon-bubble');

  if (!drawer || drawer.dataset.initialized) return;
  drawer.dataset.initialized = 'true';
  let previousFocus = null;
  drawer.inert = true;

  // ── Ouvrir / Fermer ──────────────────────────────────────
  function openCart() {
    previousFocus = document.activeElement;
    drawer.inert = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.classList.add('hn-nav-open'); // bloque scroll body
    if (closeBtn) closeBtn.focus();
  }

  function closeCart() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    document.body.classList.remove('hn-nav-open');
    drawer.inert = true;
    if (previousFocus && previousFocus.isConnected) previousFocus.focus();
  }

  if (cartTrigger) {
    // capture: true → on intercepte AVANT le JS Dawn qui écoute en bubble
    cartTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation(); // bloque tous les autres listeners sur cet élément
      openCart();
    }, true); // capture phase
  }

  // Intercepter aussi tous les liens qui pointent vers /cart
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href="/cart"]');
    if (link) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openCart();
    }
  }, true);

  if (closeBtn)  closeBtn.addEventListener('click', closeCart);
  if (overlay)   overlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart();
    if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    const controls = Array.from(drawer.querySelectorAll('a[href], button, input, select')).filter(el => !el.disabled && el.getClientRects().length);
    if (!controls.length) return;
    const first = controls[0], last = controls[controls.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // ── API Shopify AJAX ─────────────────────────────────────
  async function updateCart(updates) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
    return res.json();
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    });
    return res.json();
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function renderCartCount(cart) {
    document.querySelectorAll('.hn-header__cart').forEach(function (trigger) {
      trigger.setAttribute('aria-label', 'Panier (' + cart.item_count + ')');
      let badge = trigger.querySelector('.hn-header__cart-badge');
      if (!badge && cart.item_count > 0) {
        badge = document.createElement('span');
        badge.className = 'hn-header__cart-badge';
        trigger.appendChild(badge);
      }
      if (badge) {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    });
  }

  // ── Rerender complet du drawer ───────────────────────────
  // Retourne une Promise pour pouvoir être await-ée par les appelants
  function reloadDrawer() {
    return fetch('/?sections=cart-drawer')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (!data['cart-drawer']) return;

        const tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];

        // Body (liste articles + état vide)
        const newBody = tmp.querySelector('#hn-cart-body');
        const bodyEl  = document.getElementById('hn-cart-body');
        if (newBody && bodyEl) bodyEl.innerHTML = newBody.innerHTML;

        // Footer — remplacer l'ÉLÉMENT entier (outerHTML) pour synchroniser
        // les classes ET le contenu en une seule opération
        const newFooter      = tmp.querySelector('#hn-cart-footer');
        const existingFooter = document.getElementById('hn-cart-footer');
        if (newFooter && existingFooter) {
          existingFooter.replaceWith(newFooter.cloneNode(true));
        }

        // Compteur dans le header du drawer
        const newCount = tmp.querySelector('#hn-cart-count');
        const countEl  = document.getElementById('hn-cart-count');
        if (newCount && countEl) countEl.textContent = newCount.textContent;

        // Badge icône panier dans la navbar
        return getCart().then(function(cart) {
          renderCartCount(cart);
          bindEvents();
          initUpsellCarousel();
        });
      })
      .catch(function() {
        window.location.reload();
      });
  }

  async function updateCartBadge() {
    const cart = await getCart();

    // Badge header
    renderCartCount(cart);

    // Titre drawer
    const count = document.getElementById('hn-cart-count');
    if (count) count.textContent = `(${cart.item_count})`;

    // Footer CTA — prix total et visibilité
    const footer = document.getElementById('hn-cart-footer');
    const checkout = document.getElementById('hn-cart-checkout');
    if (footer) {
      footer.classList.toggle('hn-cart-drawer__footer--hidden', cart.item_count === 0);
    }
    if (checkout && cart.item_count > 0) {
      // Formater le prix (Shopify retourne les centimes)
      const price = (cart.total_price / 100).toFixed(2).replace('.', ',');
      checkout.textContent = `Commander ${price} €`;
    }
  }

  // ── Bind events (appellé après chaque rerender) ──────────
  function bindEvents() {
    // Steppers quantité
    document.querySelectorAll('.hn-qty-stepper').forEach(function (stepper) {
      if (stepper.dataset.initialized) return;
      stepper.dataset.initialized = 'true';
      const key = stepper.dataset.key;
      const valEl = stepper.querySelector('.hn-qty-stepper__val');
      const minusBtn = stepper.querySelector('.hn-qty-stepper__btn--minus');
      const plusBtn  = stepper.querySelector('.hn-qty-stepper__btn--plus');

      if (minusBtn) {
        minusBtn.addEventListener('click', async function () {
          const current = parseInt(valEl.textContent, 10);
          if (current <= 1) return; // supprimer via le bouton Supprimer
          valEl.textContent = current - 1;
          await updateCart({ [key]: current - 1 });
          reloadDrawer();
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', async function () {
          const current = parseInt(valEl.textContent, 10);
          valEl.textContent = current + 1;
          await updateCart({ [key]: current + 1 });
          reloadDrawer();
        });
      }
    });

    // Supprimer articles
    document.querySelectorAll('.hn-cart-item__remove').forEach(function (btn) {
      if (btn.dataset.initialized) return;
      btn.dataset.initialized = 'true';
      btn.addEventListener('click', async function () {
        const key = btn.dataset.key;
        await updateCart({ [key]: 0 });
        reloadDrawer();
      });
    });

    // Ajouter upsell
    document.querySelectorAll('.hn-upsell-card__add').forEach(function (btn) {
      if (btn.dataset.initialized) return;
      btn.dataset.initialized = 'true';
      btn.addEventListener('click', async function () {
        const variantId = parseInt(btn.dataset.variantId, 10);
        btn.disabled = true;
        btn.style.opacity = '0.5';
        await addToCart(variantId);
        reloadDrawer();
      });
    });
  }

  // ── Carousel upsell ──────────────────────────────────────
  function initUpsellCarousel() {
    const track = document.getElementById('hn-upsell-track');
    if (!track || track.dataset.initialized) return;
    track.dataset.initialized = 'true';

    const cards = track.querySelectorAll('.hn-upsell-card');
    if (cards.length <= 1) return;

    const prevBtn = document.querySelector('.hn-cart-upsell__arrow--prev');
    const nextBtn = document.querySelector('.hn-cart-upsell__arrow--next');
    let current = 0;

    function goTo(index) {
      current = Math.max(0, Math.min(index, cards.length - 1));
      track.style.transform = `translateX(calc(-${current * 100}% - ${current * 12}px))`;
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === cards.length - 1;
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    goTo(0);
  }

  // ── Intercepter les formulaires add-to-cart de Dawn ─────
  // Dawn soumet le form /cart/add nativement → on intercepte pour garder le drawer
  function initAddToCartForms() {
    document.querySelectorAll('form[action$="/cart/add"]').forEach(function (form) {
      // Éviter de binder deux fois
      if (form.dataset.hnBound) return;
      form.dataset.hnBound = 'true';
      let submitting = false;

      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        // Récupérer le bouton submit Dawn
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitting || (submitBtn && submitBtn.disabled)) return;
        submitting = true;
        const addText = submitBtn && submitBtn.querySelector('[data-add-to-cart-text]');
        const originalText = addText && addText.textContent;
        let statusEl = form.querySelector('[role="status"]');
        if (!statusEl) {
          statusEl = document.createElement('p');
          statusEl.className = 'hn-product-card__status';
          statusEl.setAttribute('role', 'status');
          statusEl.setAttribute('aria-live', 'polite');
          form.appendChild(statusEl);
        }
        statusEl.textContent = '';
        delete statusEl.dataset.error;
        if (submitBtn) { submitBtn.disabled = true; submitBtn.setAttribute('aria-busy', 'true'); }
        if (addText) addText.textContent = 'Ajout en cours…';

        try {
          const formData = new FormData(form);

          const addUrl = new URL(form.action, document.baseURI);
          addUrl.pathname += '.js';
          const res = await fetch(addUrl.href, {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData
          });

          const result = await res.json();
          if (!res.ok || result.status >= 400) throw new Error(typeof result.description === 'string' ? result.description : 'Ce produit n’a pas pu être ajouté. Réessayez.');
          statusEl.textContent = 'Votre sélection a été ajoutée au panier.';

          // Succès : recharger le contenu du drawer et l'ouvrir
          await reloadDrawer();
          openCart();

        } catch (err) {
          statusEl.dataset.error = 'true';
          statusEl.textContent = err.message || 'Une erreur est survenue. Réessayez.';
        } finally {
          submitting = false;
          // Réinitialiser l'état du bouton Dawn (spinner, aria, classes)
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-disabled');
            submitBtn.removeAttribute('aria-busy');
            // Dawn utilise ces classes pour l'état de chargement
            submitBtn.classList.remove('loading', 'disabled');
            // Dawn stocke parfois le texte original dans data-loading-text
            const originalLabel = submitBtn.querySelector('.btn__text, [data-add-to-cart-text]');
            if (originalLabel) originalLabel.style.display = '';
            // Réinitialiser les spinners Dawn
            const spinner = submitBtn.querySelector('.loading__spinner, .svg-animation');
            if (spinner) spinner.style.display = 'none';
          }
          if (addText) addText.textContent = originalText;
        }
      }, true); // capture : avant les listeners Dawn
    });
  }

  // Observer les changements de DOM pour les sections chargées dynamiquement
  const observer = new MutationObserver(function () {
    initAddToCartForms();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Product sections own their submit handler and request a single drawer refresh.
  document.addEventListener('hn:cart-updated', async function () {
    await reloadDrawer();
    openCart();
  });

  // ── Init ─────────────────────────────────────────────────
  bindEvents();
  initUpsellCarousel();
  initAddToCartForms();

})();
